import { useEffect, useState } from 'react'

const useConversationId = (instanceId?: string): string | null => {
  const [current, setCurrent] = useState<string | null>(null)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_conversationId', ((e: CustomEvent) => handleChange(e)) as EventListener)
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_conversationId'))

    return () => {
      document.removeEventListener('retorik_conversationId', ((e: CustomEvent) => handleChange(e)) as EventListener)
    }
  }, [])

  return current
}

export default useConversationId
